import { SellerOffice } from "../../domain/entities/SellerOffice"

interface ContructorParams {
	id?: number
	name: string
	city: string
	address: string
	sellerId?: number
	fiscalName?: string | null
	fiscalCountry?: "ES" | "EN" | "MX" | "CA" | "US" | null
	fiscalAddress?: string | null
	paymentDays?: number | null
	nif?: string | null
	iban?: string | null
	feePercent?: number | null
}

export class SellerOfficeModel {
	public id?: number
	public name: string
	public city: string
	public address: string
	public sellerId?: number
	public fiscalName?: string | null
	public fiscalCountry?: "ES" | "EN" | "MX" | "CA" | "US" | null
	public fiscalAddress?: string | null
	public paymentDays?: number | null
	public nif?: string | null
	public iban?: string | null
	public feePercent?: number | null

	constructor(params: ContructorParams) {
		this.id = params.id
		this.name = params.name
		this.city = params.city
		this.address = params.address
		this.sellerId = params.sellerId
		this.fiscalName = params.fiscalName
		this.fiscalCountry = params.fiscalCountry
		this.fiscalAddress = params.fiscalAddress
		this.paymentDays = params.paymentDays
		this.nif = params.nif
		this.iban = params.iban
		this.feePercent = params.feePercent
	}

	static fromRawJson = (rawJson: any): SellerOfficeModel => {
		const {
			id,
			name,
			city,
			address,
			sellerId,
			fiscalName,
			fiscalCountry,
			fiscalAddress,
			paymentDays,
			nif,
			iban,
			feePercent
		} = rawJson
		return new SellerOfficeModel({
			id,
			name,
			city,
			address,
			sellerId,
			fiscalName,
			fiscalCountry,
			fiscalAddress,
			paymentDays,
			nif,
			iban,
			feePercent
		})
	}

	static fromDomain = (service: SellerOffice): SellerOfficeModel => {
		return new SellerOfficeModel({ ...service })
	}
}

declare module "./SellerOfficeModel" {
	interface SellerOfficeModel {
		toDomain(): SellerOffice
	}
}

SellerOfficeModel.prototype.toDomain = function (): SellerOffice {
	const data = this
	return new SellerOffice({ ...data })
}
